import React from "react";
import {Modal} from "components/common/Modal";
import {Spinner} from "reactstrap";
import {Select} from "components/common/Select";

export class EditMaritalStatus extends React.Component {
    constructor(props) {
        super(props);

        this.modal = React.createRef();
        this.handleEdit = this.handleEdit.bind(this);
    }

    handleEdit(event) {
        event.preventDefault();
        this.props.handleEdit("maritalStatus", () => {
            this.modal.current.hideModal();
        });
    }

    renderSubmitButton() {
        if (this.props.makingOperation) {
            return <Spinner className="spinner-color"/>;
        } else {
            return <button className={`cta-button ${this.props.maritalStatus ? "" : "disabled"}`}
                           onClick={this.handleEdit}>CAMBIAR</button>;
        }
    }

    render() {
        return (
            <Modal ref={this.modal} trigger={<button className="link-btn">Editar</button>} type={Modal.MODAL_TYPES.data}
                   title="Editar mis datos"
                   open={false}>
                <p>Indicanos tu estado civil</p>
                <Select name="maritalStatus"
                        data={this.props.options}
                        onSelect={this.props.handleChange}
                        value={this.props.maritalStatus}
                        nullItem={{name: <em>No declarado</em>}}
                        hasNullOption={false}
                        placeholder="Seleccioná tu estado civil"/>
                {this.renderSubmitButton()}
            </Modal>
        )
    }
}
